/** @format */
import "core-js/stable";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./redux/Store";

import { App } from "./App";

//export const CURRENT_BRAND = process.env.CURRENT_BRAND==='default'?null:process.env.CURRENT_BRAND;

const FrameAdvisorPlpWidget = {
	new: (config: any) => {
		return {
			render: () => {
				ReactDOM.render(
					<Provider store={store}>
						<App config={config} />
					</Provider>,
					document.querySelector(config.selector)
				);
			},
		};
	},
};

declare global {
	interface Window {
		frameAdvisorPlp: any;
	}
}
window.frameAdvisorPlp = { FrameAdvisorPlpWidget };
